exports.init = function($) {
  $("form.wpcf7-form").each(function(){
    $(this).find("input, textarea").on("keydown", function(){
      if ($(this).attr("aria-invalid") === "true") {
        $(this).attr("aria-invalid", "false");
      }
    })
  })
}